<template>
  <div class="product">
    <!--    <div class="product-img">-->
    <!--      <img src="../../images/product.jpg">-->
    <!--    </div>-->
    <banner :bannerType="product"></banner>
    <team :hideTitle="true"></team>
    <div class="white"></div>
    <pagesBottom
      :page-index="currentPage"
      :total="count"
      :page-size="pageSize"
      @change="pageChange"
    >
    </pagesBottom>
  </div>
</template>
<style src="./partner.css" scoped></style>


<script>
import mixins from "../../common/mixin";
import application from "../../common/application";
import team from "../../components/partner/partner";
import pagesBottom from "../../components/pagesBottom/pagesBottom";
import banner from "../../components/banner/banner";
export default {
  name: "product",
  components: {
    team,
    pagesBottom,
    banner,
  },
  mixins: [mixins],
  data() {
    return {
      pageDefaltIndex: 1, //分类初始
      pageSize: 3, //每页显示20条数据
      currentPage: 1, //分类当前页码
      count: 0, //总记录数
      items: [],
      productPageSize: 5,
      productPageIndex: 0,
      product: "partner",
    };
  },
  created() {
    // this.handleBannerList()
  },
  methods: {
    pageChange(page) {
      this.currentPage = page;
      // this.getList()
    },
    receive: function (count, pageIndex) {
      this.count = count;
      this.currentPage = pageIndex;
    },
    // //获取轮播图列表
    // handleBannerList:function(){
    //     let data= {
    //         "pageIndex": 0,
    //         "pageSize": 3,
    //         "type":'product'
    //
    //     };
    //
    //     this.request({
    //         url: '/web/banner/list',
    //         data:data,
    //         success: (response) => {
    //             this.bannerList=response.data.records;
    //             console.log(this.bannerList)
    //
    //         },
    //         error: (response) => {
    //             this.$Message.error(response.message);
    //         },
    //         complete: () => {
    //         }
    //     });
    // },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/partner/partner.vue